import {showErrorMessage, showSuccessMessage} from '@/helper';

export default {

    /**
     * Načte všechny typy notifikací s jejich globálním nastavením CC/BCC.
     * Dostupné pouze pro ADMIN a SUPERADMIN.
     */
    getAll() {
        return new Promise((resolve, reject) => {
            http.get('api/notification-settings').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    },

    /**
     * Uloží globální nastavení CC/BCC pro daný typ notifikace.
     *
     * @param {string} notificationType - Hodnota z NotificationTypeEnum (např. 'forgotten_password')
     * @param {object} data - Objekt s cc_intermediary, cc_intermediary_person, cc_emails, bcc_*
     */
    saveGlobal(notificationType, data) {
        return new Promise((resolve, reject) => {
            http.put('api/notification-settings/' + notificationType, data).then(response => {
                showSuccessMessage('Nastavení notifikace bylo uloženo.');
                resolve(response.data);
            }).catch(error => {
                showErrorMessage('Nepodařilo se uložit nastavení notifikace.');
                reject(error);
            });
        });
    },

    /**
     * Načte všechny typy notifikací s globálním i tenantovým nastavením.
     *
     * @param {object} params - Volitelné query parametry (např. { intermediary_id: 5 } pro admina)
     */
    getTenantAll(params = {}) {
        return new Promise((resolve, reject) => {
            http.get('api/notification-settings/tenant', {params}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    },

    /**
     * Uloží tenantové nastavení CC/BCC pro daný typ notifikace.
     *
     * @param {string} notificationType - Hodnota z NotificationTypeEnum
     * @param {object} data - Objekt s mode, cc_*, bcc_*, intermediary_id (pro admina)
     */
    saveTenant(notificationType, data) {
        return new Promise((resolve, reject) => {
            http.put('api/notification-settings/tenant/' + notificationType, data).then(response => {
                showSuccessMessage('Nastavení notifikace bylo uloženo.');
                resolve(response.data);
            }).catch(error => {
                showErrorMessage('Nepodařilo se uložit nastavení notifikace.');
                reject(error);
            });
        });
    },
}